angular.module('pitch.media')
.factory('AuditionHandler', function(Audition, Player, growl) {
    'use strict';

    return function(e, track, onComplete, context, format) {
        Audition.save({
            subject: track.id,
            context: context,
            format: format
        }, function(data) {
            var params = {
                id: track.id,
                mp3: data.mp3,
                label: {
                    name: (track.full_name || track.name) + ' - ' + track.artist_names.join(', ')
                },
                onComplete: onComplete || function() {}
            };

            if (track._links) {
                if (track._links.artwork) {
                    params.artwork = {
                        src: track._links.artwork,
                        onClick: function() {
                        }
                    };
                }

                if (track._links.waveform &&
                    data.mp3.indexOf('_30s.mp3') === -1 //we don't have waveforms for 30second clips
                ) {
                    params.waveform = {
                        url: track._links.waveform
                    };
                }
            }

            Player.play(params);
        }, function(resp) {
            if (resp.status === 403) {
                growl.error('We\'re very sorry but you do not have the necessary permissions required for auditioning this track.');
            } else {
                //the user probably clicked cancel
            }
        });
    };
});





// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/angular/services/AuditionHandler.js